"use client";

import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useRouter } from "next/navigation";
import { showToast } from "@/components/ui/sonner";
import { loginMfaVerify } from "@/lib/api/generated";
import { currentCometToken } from "@/lib/cometly";
import { buildPostAuthRedirectPath } from "@/lib/invitation-links";
import { clearMfaChallenge } from "../lib/mfa-storage";

export function useMfaVerify() {
  const queryClient = useQueryClient();
  const router = useRouter();

  return useMutation({
    // The login POST bails to the MFA challenge before the backend resolves
    // a user, so the click token captured on the login page (snapshotted to
    // localStorage; the 2FA page has no pixel) rides the verify call.
    mutationFn: (data: {
      code: string;
      pending_authentication_token: string;
      authentication_challenge_id: string;
    }) => loginMfaVerify({ ...data, comet_token: currentCometToken() }),
    onSuccess: () => {
      clearMfaChallenge();
      queryClient.invalidateQueries({ queryKey: ["auth"] });
      router.push(buildPostAuthRedirectPath("/projects"));
    },
    onError: (error: Error) => {
      showToast.error("Verification failed", {
        description: error.message || "Invalid verification code.",
      });
    },
  });
}
